import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { EcptAuthSession } from '../../types/api/ecpt/auth';

interface UserState {
  session: EcptAuthSession | null;
}

const userSlice = createSlice({
  name: 'user',
  initialState: { session: null } as UserState,
  reducers: {
    setUserSession(state, action: PayloadAction<EcptAuthSession>) {
      state.session = action.payload;
    },
    clearUserSession(state) {
      state.session = null;
    },
  },
});

export const { setUserSession, clearUserSession } = userSlice.actions;
export default userSlice.reducer;
